import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiService from 'app/services/apiService';
import { setLoading, setLoadingFinished } from './loadingSlice';

export const fetchRssFeeds = createAsyncThunk('rss/fetch', async (payload, { dispatch }) => {
  dispatch(setLoading());
  try {
    const res = await apiService.fetchRss(payload.date);
    return { responseData: res?.data, payload };
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const fetchCertFeeds = createAsyncThunk('cert/fetch', async (payload, { dispatch }) => {
  dispatch(setLoading());
  try {
    const res = await apiService.fetchCert(payload.date);
    return { responseData: res?.data, payload };
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const enisaRssFeeds = createAsyncThunk('enisa/fetch', async (payload, { dispatch }) => {
  dispatch(setLoading());
  try {
    const res = await apiService.fetchEnisa(payload.date);
    return { responseData: res?.data, payload };
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const dashboardWidgetSlice = createSlice({
  name: 'widgets',
  initialState: {
    widgets: [],
    feeds: [],
    enisaFeeds: [],
    certFeeds: [],
    isEnisaFeedsFetched: false,
    isRssFeedsFetched: false,
    isCertFeedsFetched: false,
    widgetPushed: false,
    isSettingsFetched: false,
    loading: true,
    count: 6,
    newsCount: 0,
    certCount: 0,
  },

  reducers: {
    setLoad(state) {
      state.loading = true;
    },

    setLoadingFalse(state) {
      state.loading = false;
    },
  },

  extraReducers(builder) {
    builder.addCase(fetchRssFeeds.fulfilled, (state, { payload }) => {
      state.feeds = payload?.responseData;
      state.isRssFeedsFetched = payload.payload.count === 3 ? true : false;
      state.newsCount = payload.payload.count;
    });
    builder.addCase(fetchCertFeeds.fulfilled, (state, { payload }) => {
      state.certFeeds = payload?.responseData;
      state.isCertFeedsFetched = payload.payload.count === 3 ? true : false;
      state.certCount = payload.payload.count;
    });
    builder.addCase(enisaRssFeeds.fulfilled, (state, { payload }) => {
      state.enisaFeeds = payload?.responseData;
      state.isEnisaFeedsFetched = payload.payload.count === 9 ? true : false;
      state.count = payload.payload.count;
    });
  },
});

export const { setLoad, setLoadingFalse } = dashboardWidgetSlice.actions;
export default dashboardWidgetSlice.reducer;
